import { Button, Popup } from 'devextreme-react';
import './CountertopUniversityCertificateViewer.scss';
import { useCountertopUniversity } from '../contexts/countertopUniversityContext';
import { CountertopUniversityCertificationProps } from '../types/CountertopUniversityCertificationProps';
import { useQueryClient } from '@tanstack/react-query';
import CountertopUniversityCertificateViewerContent from './CountertopUniversityCertificateViewerContent';
import { formatShortDateShortTime } from '../../../../utils/date-utils';

const CountertopUniversityCertificateViewer = (props: CountertopUniversityCertificationProps) => {
    const context = useCountertopUniversity();
    const queryClient = useQueryClient();

    const handleClose = () => {
        context.setCertificateViewerPopupVisible(false);
        context.setCertificationPopupVisible(false);
        if (context.onDataRefresh) {
            context.onDataRefresh();
        }
        queryClient.invalidateQueries(['countertop-university']);
    };

    return (
        <>
            <Popup
                visible={context.certificateViewerPopupVisible} 
                title="Completion Certificate"
                width={1180}
                height={800} 
                onHiding={handleClose}
            >
                <div>
                    <CountertopUniversityCertificateViewerContent
                        certUrl={props.certUrl}
                        date={formatShortDateShortTime(props.completedDate)}
                        email={props.email}
                    />
                    <div className="certification-button-container">
                        <Button
                            text={'Close'}
                            type="default"
                            onClick={handleClose}
                        />
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default CountertopUniversityCertificateViewer;